module.exports = __webpack_public_path__ + "img/calendar-2024.jpg-768x402.92891a41.webp";